import { call, put } from "redux-saga/effects";
import { API_METHODS, ENDPOINTS } from "../../../endpoint";
import { apiRequest } from "../../../../Utils/axiosApi";
import { Actions } from "../../../constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";

// apiRequest resolves (not throws) on a 4xx/5xx; the API's message sits on the axios error
const errorMessageOf = (result) =>
  result?.response?.data?.errorMessage ||
  result?.data?.errorMessage ||
  result?.message;

export function* apiUpdateWaf(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.JENKINS}/updateWaf?siteId=${action.data.siteId}&status=${action.data.status}`,
      method: API_METHODS.PUT,
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      return result;
    } else {
      action.meta.onError();

      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
  }
}

export function* apiSftpUserCreate(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/createSftpUser?domainName=${action.data?.domainName}&siteId=${action.data?.siteId}&secretNameSuffix=${action.data?.secretNameSuffix}&secretPassword=${action.data?.secretPassword}`,
      method: API_METHODS.POST,
    });
    if (result.isApiSuccessful) {
      setTimeout(() => {
        action?.meta?.onSuccess(result.data);
      }, 250);
      return result;
    } else {
      action?.meta?.onError?.(errorMessageOf(result));
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError?.(errorMessageOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiSftpUserList(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/listSftpUsers?domainName=${action.data?.domainName}&siteId=${action.data?.siteId}`,
      method: API_METHODS.GET,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_LIST_SFTP_USER,
        data: result.data,
      });

      action.meta.onSuccess(result.data);
      return result;
    } else {
      action?.meta?.onError?.(errorMessageOf(result));
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError?.(errorMessageOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiChangedWpCache(action) {
  let tempResult = null;
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.POST,
      // EBS (v2) sites: the API edits wp-config.php in the site pod itself, no Jenkins
      url: action.devtools.ebsSite
        ? `${ENDPOINTS.SITE_DETAILS}/${action.devtools.siteId}/ebsCache/${action.devtools.action}`
        : `${ENDPOINTS.SITE_DETAILS}/${action.devtools.siteId}/cache/${action.devtools.action}/${action.devtools.stagingDomainName}`,
    });
    tempResult = result;
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      let temp = {
        ...action.devtools.selectedSite,
        wpCache: action.devtools.action,
      };
      yield put({ type: Actions.SET_SELECTED_SITE_DETAILS, data: temp });
      return result;
    } else {
      // e.g. 406 from the API: without this the confirm popup spins forever
      action?.meta?.onError?.(errorMessageOf(result));
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError?.(errorMessageOf(tempResult) || errorMessageOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiChangedWpDebug(action) {
  let tempResult = null;

  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.POST,
      // EBS (v2) sites: the API edits wp-config.php in the site pod itself, no Jenkins
      url: action.devtools.ebsSite
        ? `${ENDPOINTS.SITE_DETAILS}/${action.devtools.siteId}/ebsDebug/${action.devtools.action}`
        : `${ENDPOINTS.SITE_DETAILS}/${action.devtools.siteId}/debug/${action.devtools.action}/${action.devtools.stagingDomainName}`,
    });
    tempResult = result;
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      let payload = {
        ...action.devtools.selectedSite,
        wpDebug: action.devtools.action,
      };
      yield put({ type: Actions.SET_SELECTED_SITE_DETAILS, data: payload });
      if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
      } else {
        console.log(
          "After API Proimse of All Sites (if block)",
          getStore().getState()
        );
      }
      return result;
    } else {
      if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
      } else {
        console.log(
          "After API Proimse of All Sites (else block)",
          getStore().getState()
        );
      }
      action?.meta?.onError?.(errorMessageOf(result));
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError?.(errorMessageOf(tempResult) || errorMessageOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCacheInvalidation(action) {
  try {
    const result = yield call(apiRequest, {
      // EBS (v2) sites: invalidate the site's CloudFront distribution; v1 goes to the GCP URL map
      url: action.data.ebsSite
        ? `${ENDPOINTS.SITE_DETAILS}/${action.data.siteId}/ebsCacheInvalidation`
        : `/siteDetails/cacheInvalidation?siteName=${action.data.siteName}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess();
      return result;
    } else {
      action.meta.onError(errorMessageOf(result));
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError?.(errorMessageOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDeleteSftpUser(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/deleteSftpUser?domainName=${action.data?.domainName}&siteId=${action.data?.siteId}&secretNameSuffix=${action.data?.secretNameSuffix}`,
      method: "DELETE",
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);

      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action?.meta?.onError?.(errorMessageOf(err));
    return { isApiSuccessful: false, data: err };
  }
}

// EBS (v2) sites: one SFTP login per site (the site name, with the SSH password chosen at
// creation). Host and port come from the API, which looks the site's port up on the shared
// NLB; a password is never returned.
export function* apiEbsSftpDetails(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/${action.data?.siteId}/ebsSftp`,
      method: API_METHODS.GET,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({ type: Actions.SET_EBS_SFTP_DETAILS, data: result.data });
      action?.meta?.onSuccess?.(result.data);
      return result;
    }
    getStore().dispatch({ type: Actions.SET_EBS_SFTP_DETAILS, data: { available: false } });
    action?.meta?.onError?.(errorMessageOf(result));
    return { isApiSuccessful: false, data: null };
  } catch (err) {
    action?.meta?.onError?.(errorMessageOf(err));
    return { isApiSuccessful: false, data: err };
  }
}
